import React, { useEffect, useState } from 'react'
import { Text } from '../../../../modules/Dashboard'
import { motion } from "framer-motion"
import { defaultTransition, IMG_SIZE } from './common'
import { HorizontalGradient } from './HorizontalGradient'
import Spinner from './Spinner'
import { VerticalGradient } from './VerticalGradient'

const Step4 = ({ done }) => {

    return (
        <>
            {
                done &&
                <>
                    <VerticalGradient className={"absolute top-0 left-0 !w-[1px] !h-[428px]"} done />
                    <VerticalGradient className={"absolute top-0 right-0 !w-[1px] !h-[428px]"} done />
                </>
            }
            <div className='absolute top-3 ltr:right-3 rtl:left-3'>
                <Spinner done={done} />
            </div>
            <div className='flex flex-col items-start gap-5'>
                <motion.div
                    initial={{ x: -500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='max-w-[250px]'
                >
                    <Text tid={"loading-title-step-4"} className={`text-2xl text-wrap ${done ? "!text-success" : "!text-warn"}`} />
                </motion.div>
                <motion.div
                    initial={{ x: 500, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={defaultTransition}
                    className='mt-5'
                >
                    <Text tid={"loading-desc-step-4"} className='! opacity-90' />
                </motion.div>
                <HorizontalGradient done={done} x={-400} />
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ ...defaultTransition, delay: 1.5 }}
                >
                    <img src={require('../../assets/loading/liquidity-zones.webp')} alt='liquidity-zone' width={IMG_SIZE.width} height={IMG_SIZE.height} className='object-cover rounded-xl' />
                </motion.div>
            </div>
        </>
    )
}

export default Step4